import script from "./ChangelogBlog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangelogBlog.vue?vue&type=script&setup=true&lang=js"

import "./ChangelogBlog.vue?vue&type=style&index=0&id=2665137c&lang=css"

const __exports__ = script;

export default __exports__